import {Socket} from 'phoenix'
import 'angular'
import 'angular-ui-bootstrap'

let lobby = function() {
		angular.module('lobby')

		.controller('LobbyController', [
			'$scope',
			'$uibModal',
			'Notification',
			function(
				$scope,
				$uibModal,
				notification
			) {

			var self = this;
			var newGameModalOpen = false;
			var deleteBoardModalOpen = false;

			$scope.games = [];
			$scope.boards = [];
			$scope.weapons = [];
			$scope.boardFilter = '';
			$scope.boardSorting = 'name';
			$scope.boardSortDescending = false;
			$scope.gameSorting = 'name';
			$scope.gameSortDescending = false;

			$scope.boardImagePath = '';

			$scope.toggleDropdown = (item, $event) => {
				$event.preventDefault();
				$event.stopPropagation();
				item.isOpen = !item.isOpen;
			};

			$scope.sortBoards = (property) => {
				if ($scope.boardSorting === property)
					$scope.boardSortDescending = !$scope.boardSortDescending;
				else {
					$scope.boardSorting = property;
					$scope.boardSortDescending = false;
				}
			};

			$scope.sortGames = (property) => {
				if ($scope.gameSorting === property)
					$scope.gameSortDescending = !$scope.gameSortDescending;
				else {
					$scope.gameSorting = property;
					$scope.gameSortDescending = false;
				}
			};

			self.socket = new Socket('/lobbysocket', {params: {token: window.userToken}});
			self.socket.connect();

			self.channel = self.socket.channel('lobby', {});

			self.channel.on('updated_games', payload => {
				$scope.$applyAsync(function() {
					$scope.games = payload.games;
				});
			});

			self.channel.on('new_game', payload => {
				$scope.$applyAsync(() => {
					$scope.games.push(payload);
				});
			});

			self.channel.on("updated_spectators", payload => {
				$scope.$applyAsync(() => {
					$scope.games.find((game) => game.game_id === payload.game_id).number_of_spectators = payload.number_of_spectators;
				});
			});

			self.channel.on('terminate_game', payload => {
				$scope.$applyAsync(() => {
					var index = $scope.boards.findIndex((element) => element.game_id === payload.game_id);
					$scope.games.splice(index, 1);
				});
			});

			self.channel.on('updated_players', payload => {
				$scope.$applyAsync(() => {
					var index = $scope.games.findIndex((element) => element.game_id === payload.game_id);
					$scope.games[index].players = payload.players;
				});
			});

			self.channel.on('updated_boards', payload => {
				$scope.$applyAsync(() => {
					$scope.boards = payload.boards;
				});
			});

			self.channel.on('board_added', payload => {
				$scope.$applyAsync(() => {
					$scope.boards.push(payload);
				});
			});

			self.channel.on('board_removed', payload => {
				$scope.$applyAsync(() => {
					var index = $scope.boards.findIndex((element) => element.name === payload.name);
					$scope.boards.splice(index, 1);
				});
			});

			self.channel.on('wrong_password', payload => {
				$scope.$applyAsync(() => {
					notification.error("Wrong password entered. Deletion of board not allowed.");
				});
			});

			self.channel.on('weapon_list', payload => {
				$scope.$applyAsync(() => {
					$scope.weapons = payload.weapons;
				});
			});

			self.channel.on('error', (payload) => {
				$scope.$applyAsync(() => {
					notification.error(payload.message);
				});
			});

			self.channel.on('success', (payload) => {
				$scope.$applyAsync(() => {
					notification.success(payload.message);
				});
			})

			self.channel.join()
				.receive('ok', resp => {
					console.log('Joined successfully', resp);
					self.channel.push('get_games', {});
					self.channel.push('get_boards', {});
					self.channel.push('get_weapons', {});
				})
				.receive('error', resp => console.log('Unable to join', resp));

			$scope.delete_board = (boardName) => {
				if (deleteBoardModalOpen)
					return;
				
				deleteBoardModalOpen = true;

				let modalInstance = $uibModal.open({
					templateUrl: 'lobby/deleteBoardModal.html',
					controller: 'DeleteBoardModalController',
					backdrop: 'static',
					resolve: {
						boardName: function () {
							return boardName;
						}
					}
				});

				modalInstance.result.then(
					(password) => {
						self.channel.push("delete_board", {boardName, password});
						deleteBoardModalOpen = false;
					},
					() => deleteBoardModalOpen = false
				);
			}

			$scope.new_game = (boardName) => {
				if(newGameModalOpen)
					return;

				newGameModalOpen = true;

				var modalInstance = $uibModal.open({
					templateUrl: 'lobby/newGameModal.html',
					controller: 'NewGameModalController',
					backdrop: 'static',
					resolve: {
						boardName: function () {
							return boardName;
						},
						weapons: function () {
							return $scope.weapons;
						}
					}
				});

				modalInstance.result.then(
					(gameOptions) => {
						self.channel.push("create_game", gameOptions);
						newGameModalOpen = false;
					},
					() => newGameModalOpen = false
				);
			};

		}]);
};

export default lobby;
